import './rxjs-extensions';

import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { StarratingComponent } from './starrating.component';
import { StarratingRoutingModule } from './starrating.routing.module';
import { ReactiveFormsModule } from '@angular/forms';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StarratingRoutingModule,
    ReactiveFormsModule
  ],
  exports: [
    StarratingComponent
  ],
  declarations: [
    StarratingComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class StarratingModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: StarratingModule,
      providers: [GenericdatasetService]
    };
  }
}
